import { useSystemContainerStore } from '../store/systemContainerStore';

export function useSystemContainer() {
  const isLoading = useSystemContainerStore((state) => state.isLoading);
  const setLoading = useSystemContainerStore((state) => state.setLoading);

  return {
    isLoading,
    setLoading,
  };
}

